<div class="menu" id="menu">
  <ul class="menu-list" *ngIf="workOrder$ | async as workOrder">
    <li class="menu-item">
      <button
        mat-button
        aria-label="Back to Work Orders"
        onclick="this.blur()"
        (click)="backToWorkOrders()"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">arrow_back_ios</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.back" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="assignVisible$ | async">
      <button
        mat-button
        aria-label="Opens the 'Assign Specialists' Pane."
        onclick="this.blur()"
        (click)="openAssign(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">group_add</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.specialists" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="(isSupervisor$ | async) && (notMineVisible$ | async)">
      <button
        mat-button
        aria-label="Opens the 'Work Order Not Mine' Pane."
        onclick="this.blur()"
        (click)="openNotMine(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">report_problem</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.not-mine" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="employeeVisitsVisible$ | async">
      <button
        mat-button
        aria-label="Opens the 'Employee Visits' Pane."
        onclick="this.blur()"
        (click)="openEmployeeVisits(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">access_time</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.add-visits" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="workOrderIsOnFinishedState$ | async">
      <button
        mat-button
        aria-label="Opens the 'Extra time' Pane."
        onclick="this.blur()"
        (click)="openWorkOrderExtraTime(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">access_time</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.extra-time" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="workOrderIsOnFinishedState$ | async">
      <button
        mat-button
        aria-label="Opens the 'Reject Work Order' Pane."
        onclick="this.blur()"
        (click)="openRejectWorkOrder(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon">cancel</mat-icon>
          <span class="menu-name">{{
            "workorder.detail-actions.reject" | translate
          }}</span>
        </div>
      </button>
    </li>
    <li class="menu-item" *ngIf="workOrderIsOnFinishedState$ | async">
      <button
        mat-button
        aria-label="Opens the 'Validate Work Order' Pane."
        onclick="this.blur()"
        (click)="openValidateWorkOrder(workOrder)"
      >
        <div>
          <mat-icon [inline]="true" class="menu-icon"
            >check_circle_outline</mat-icon
          >
          <span class="menu-name">{{
            "workorder.detail-actions.validate" | translate
          }}</span>
        </div>
      </button>
    </li>
  </ul>
</div>
